<template>
	<div class="con">
		<div class="header">
			<h1>挂号预约确认</h1>
		</div>
		<div class="list">
			<div class="card">
				<div class="list-con">
					<label>医生姓名</label>
					<div class="doctor-name">{{ doctorUser.YSXM }}</div>
				</div>
				<div class="list-con" v-if="doctorUser.ksmc">
					<label>就诊科室</label>
					<div>{{ doctorUser.ksmc }}</div>
				</div>
				<div class="list-con">
					<label>挂号类别</label>
					<van-radio-group v-model='czpb' direction="horizontal" class="radio-group">
						<van-radio :name="0" shape="square" class="radio-item">初诊</van-radio>
						<van-radio :name="1" shape="square" class="radio-item">复诊</van-radio>
					</van-radio-group>
				</div>

				<div class="list-con">
					<label>挂号时间</label>
					<div class="time-info">
						<div class="time">{{ doctorUser.chooseTime }}</div>
						<div class="time-period">{{ doctorUser.ZBLB == 1 ? '上午' : '下午' }}</div>
					</div>
				</div>
			</div>

			<div class="time-section">
				<h2 class="section-title">选择时间段</h2>
				<div class="box-pa" v-if="phaseList">
					<div @click="changePhase(item)" v-for="(item, index) in phaseList" :key="'p' + index" class="phase"
						:class="{ 'phase-active': currentPhase && currentPhase.PHASEID == item.PHASEID, 'phase-not-select': item.TOTAL == 0 }">
						<div class="name">{{ item.PHASENAME }}</div>
						<div class="surplus">{{ item.TOTAL > 0 ? '剩余：' + item.TOTAL : '已约满' }}</div>
					</div>
				</div>
				<div v-else class="loading-phase">
					<van-loading type="spinner" color="#27BEC4" />
					<div class="loading-text">加载时间段中...</div>
				</div>
			</div>

			<div class="patient-section">
				<h2 class="section-title">就诊人信息</h2>
				<div class="add-patient" @click="addBtn">
					<div class="add-left" v-if="cardUserInfo.name == undefined || cardUserInfo.name == ''">
						<van-icon name="add" color="#27BEC4" size="24px" />
						<span>添加就诊人</span>
					</div>
					<div class="add-left" v-else>
						<van-icon name="friends-o" color="#27BEC4" size="32px" />
						<div class="patient-info">
							<div class="patient-name">就诊人：<span class="patientName">{{ cardUserInfo.name }}</span></div>
							<div class="patient-detail" v-if="cardUserInfo.sfzh">身份证：{{ cardUserInfo.sfzh }}</div>
						</div>
					</div>
					<van-icon name="arrow" color="#999" />
				</div>
			</div>

			<van-button v-if="disabled == false" class="confirmation" @click="addMakeRegister">确认挂号</van-button>
			<van-button v-else class="confirmation" disabled="disabled">确认挂号</van-button>
		</div>

	</div>
</template>

<script>
export default {
	name: 'regConfirmation',
	data() {
		return {
			msg: '挂号预约确认',
			czpb: 0, //0、初诊 2、复诊
			doctorUser: {
			},
			patientName: '',
			disabled: false,
			cardUserInfo: '',
			timer: null,
			phaseList: [],
			currentPhase: undefined
		}
	},
	methods: {
		//添加挂号人
		addBtn() {
			this.$router.push({
				path: '/patient',
			})
		},

		//保存微信挂号信息
		addMakeRegister(e) {
			if (this.disabled) {
				return
			}
			let that = this;

			this.disabled = true;
			if (!this.currentPhase) {
				this.$toast("请选择预约时间段")
				setTimeout(function () {
					that.disabled = false;
				}, 3000)
				return false;
			}
			if (this.cardUserInfo.name == undefined || this.cardUserInfo.name == '') {
				this.$toast("就诊人不能为空")
				setTimeout(function () {
					that.disabled = false;
				}, 3000)
				return false;
			}


			let t = this.currentPhase.STARTTIME;
			const phaseid = this.currentPhase.PHASEID

			let url = '/outpatient/addMakeRegister?brid=' + that.cardUserInfo.brid + '&ghsj=' + t + '&ghlb=' + that.doctorUser.ZBLB + '&ksdm=' + that.doctorUser.ksdm + '&czpb=' + this.czpb + '&ysdm=' + that.doctorUser.YSDM + '&phaseid=' + phaseid;
			clearTimeout(that.timer)
			that.timer = setTimeout(() => {
				that.$Axios.Post(url, null).then(data => {
					setTimeout(function () {
						that.disabled = false;
					}, 2000)
					console.log(data)
					if (data.data.code == 0) {
						that.$toast("预约挂号成功")
						setTimeout(function () {
							that.$router.replace({
								path: '/user'
							})
						}, 1000)
					} else {
						that.$toast(data.data.msg)
						console.log(data.data.msg)
						//that.$toast('没有门诊档案')
					}
				}).catch(err => {
					setTimeout(function () {
						that.disabled = false;
					}, 3000)
					console.log(err)
				})
				that.timer = null;
			}, 800)
		},
		//获取缓存的默认卡号信息
		getCardUserInfo() {
			var cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'))
			if (cardUserInfo) {
				this.cardUserInfo = cardUserInfo;
			}
		},
		loadMx() {
			this.currentPhase = undefined
			let url = '/outpatient/msYszbMx?zbrq=' + this.doctorUser.chooseTime + '&ksdm=' + this.doctorUser.ksdm + '&ysdm=' + this.doctorUser.YSDM + '&zblb=' + this.doctorUser.ZBLB

			this.phaseList = []
			this.$Axios.Get(url).then(data => {
				if (data.code == 0) {
					this.phaseList = data.msg
				} else {
					this.$toast(data.msg)
				}
			});
		},

		changePhase(item) {
			if (item.TOTAL > 0) {
				this.currentPhase = item
			} else {
				this.$toast('已经没有余号，不能选择')
			}

		}

	},
	mounted() {
		this.doctorUser = this.$store.state.doctorUser;
		this.czpb = 0;
		this.getCardUserInfo();
		this.loadMx()
		console.log("doctorUser", this.doctorUser)
		console.log(this.cardUserInfo)
	},

}
</script>

<style scoped>
.con {
	min-height: 100vh;
	background-color: #f5f7fa;
	padding-bottom: 30px;
}

.header {
	background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
	padding: 20px;
	color: #fff;
	box-shadow: 0 2px 10px rgba(0,0,0,0.1);
	margin-bottom: 20px;
}

.header h1 {
	font-size: 20px;
	font-weight: 700;
	margin: 0;
}

.list {
	padding: 0 15px;
}

.card {
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 10px rgba(0,0,0,0.08);
	overflow: hidden;
	margin-bottom: 20px;
}

.time-section,
.patient-section {
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 10px rgba(0,0,0,0.08);
	padding: 20px;
	margin-bottom: 20px;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #27bec4;
	margin: 0 0 15px 0;
	padding-bottom: 10px;
	border-bottom: 1px solid #f0f0f0;
}

.box-pa {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	align-content: center;
}

.box-pa .phase {
	width: 50px;
	margin: 8px 5px;
	padding: 12px 8px;
	border-radius: 15px;
	border: 1px dashed #848484;
	color: #000;
	text-align: center;
	transition: all 0.3s ease;
	cursor: pointer;
}

.box-pa .phase:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.box-pa .phase-active {
	background-color: #27bec4;
	color: #fff;
	border: 1px solid #27bec4;
}

.box-pa .phase-not-select {
	border: 1px dashed #c8c8c8;
	color: #c8c8c8;
	cursor: not-allowed;
}

.box-pa .phase-not-select:hover {
	transform: none;
	box-shadow: none;
}

.box-pa .phase .name {
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 5px;
}

.box-pa .phase .surplus {
	font-size: 12px;
}

.loading-phase {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 0;
}

.loading-text {
	margin-top: 15px;
	font-size: 14px;
	color: #666;
}

.list-con {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px 20px;
	border-bottom: 1px solid #f0f0f0;
	color: #666;
	font-size: 15px;
}

.list-con:last-child {
	border-bottom: none;
}

.list-con label {
	color: #333;
	font-weight: 500;
}

.doctor-name {
	font-size: 16px;
	font-weight: 600;
	color: #333;
}

.radio-group {
	gap: 20px;
}

.radio-item {
	font-size: 14px;
}

.time-info {
	test-align: right;
}

.time {
	color: #FF0000;
	font-weight: 500;
	margin-bottom: 5px;
}

.time-period {
	font-size: 14px;
	color: #666;
}

.patient-info {
	flex: 1;
	margin-left: 10px;
}

.patient-name {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-bottom: 5px;
}

.patient-detail {
	font-size: 14px;
	color: #666;
}

.add-patient {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px;
	background: #f9f9f9;
	border-radius: 8px;
	transition: all 0.3s ease;
}

.add-patient:hover {
	background: #f0f8f0;
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(39,190,196,0.15);
}

.add-left {
	display: flex;
	align-items: center;
	gap: 12px;
}

.patientName {
	font-weight: 700;
	color: #27bec4;
}

.confirmation {
	margin: 20px auto;
	width: 90%;
	color: #fff;
	background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
	border-radius: 12px;
	text-align: center;
	font-size: 18px;
	font-weight: 600;
	padding: 15px 0;
	border: 0;
	box-shadow: 0 2px 10px rgba(39,190,196,0.2);
	transition: all 0.3s ease;
}

.confirmation:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(39,190,196,0.3);
}

.confirmation:disabled {
	background: #ccc;
	box-shadow: none;
	transform: none;
}

@media (max-width: 768px) {
	.box-pa .phase {
		width: calc(30% - 20px);
	}
	
	.radio-group {
		gap: 10px;
	}
}
</style>